import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-svg',
    templateUrl: './svg.component.html',
    styleUrls: ['./svg.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SvgComponent {
  @Input() name: string;
  @Input() styling: string;

  get absUrl() {
    return window.location.href.split('#')[0];
  }

}
